<div class="toolbar">
    <h3>CFG: settaggi preventivatore</h3>
</div>
<div class="zoom-controls">
    <div class="controls-row">
        <button class="icon-btn" (click)="openSearchModal()" aria-label="Cerca" title="Cerca">🔍</button>
        <button (click)="zoomIn()" class="control-btn" aria-label="Zoom in">+</button>
        <button (click)="zoomOut()" class="control-btn" aria-label="Zoom out">−</button>
    </div>
    <div class="legend">
        <div>
            <span class="legend-circle legend-active-visible"></span>
            Attivo e visibile
        </div>
        <div>
            <span class="legend-circle legend-inactive"></span>
            Inattivo
        </div>
        <div>
            <span class="legend-circle legend-invisible"></span>
            Invisibile
        </div>
        <div>
            <span class="legend-circle legend-inactive-invisible"></span>
            Inattivo e invisibile
        </div>
        <div class="legend-note">
            <em>Nota:</em> se il testo è a destra del nodo significa che non ha figli(eccetto per le Nazioni)
        </div>
    </div>
</div>


<!-- Contenitore dell’albero D3 -->
<div #diagramDiv class="diagram-container"></div>

<!-- Modale per aggiunta nodo -->
<div class="modal-backdrop" *ngIf="showModal">
    <div class="modal-box">
        <h4>Aggiungi {{ getNextLevelType(currentNode?.type || '') }}</h4>
        <input [(ngModel)]="newNodeLabel" placeholder="Nome del nodo" />
        <div class="modal-buttons">
            <button (click)="confirmAddNode()">Aggiungi</button>
            <button (click)="closeModal()">Annulla</button>
        </div>
    </div>
</div>
<app-cfg-phase-dialog *ngIf="selectedPhase" [phaseData]="selectedPhase" (close)="selectedPhase = null"
    (save)="onPhaseSave($event)"></app-cfg-phase-dialog>
<app-cfg-macrophase-dialog *ngIf="selectedMacroPhase" [macroPhaseData]="selectedMacroPhase"
    (close)="onMacroPhaseDialogClose()" (save)="onMacroPhaseSave($event)">
</app-cfg-macrophase-dialog>
<app-cfg-category-dialog *ngIf="selectedCategory" [categoryData]="selectedCategory" (close)="onCategoryDialogClose()"
    (save)="onCategoryDialogSave($event)">
</app-cfg-category-dialog>
<!-- Modale Ricerca -->
<div class="modal-backdrop" *ngIf="showSearchModal">
    <div class="modal-box search-modal">
        <div class="search-header">
            <h4>Ricerca nodo</h4>
            <button class="close-btn" (click)="closeSearchModal()">✕</button>
        </div>

        <div class="search-bar">
            <input [(ngModel)]="searchQuery" (keyup.enter)="performSearch()"
                placeholder="Cerca per nome (LOB, Categoria, Macrofase, Fase)..." />
            <button (click)="performSearch()" [disabled]="searchLoading">Cerca</button>
        </div>

        <div class="search-results" *ngIf="!searchLoading && searchResults.length">
            <div class="result-row" *ngFor="let r of searchResults; trackBy: trackByResult"
                (click)="navigateToResult(r)">
                <div class="crumb">
                    <span class="chip">Nazione</span> {{ r.nationName }}
                    <ng-container *ngIf="r.labels.branchName">
                        &nbsp;→ <span class="chip">LOB</span> {{ r.labels.branchName }}
                    </ng-container>
                    <ng-container *ngIf="r.labels.categoryName">
                        &nbsp;→ <span class="chip">Categoria</span> {{ r.labels.categoryName }}
                    </ng-container>
                    <ng-container *ngIf="r.labels.macroName">
                        &nbsp;→ <span class="chip">Macrofase</span> {{ r.labels.macroName }}
                    </ng-container>
                    <ng-container *ngIf="r.labels.phaseName">
                        &nbsp;→ <span class="chip">Fase</span> {{ r.labels.phaseName }}
                    </ng-container>
                </div>
                <div class="type">{{ r.type }}</div>
            </div>
        </div>

        <div class="search-empty" *ngIf="!searchLoading && !searchResults.length">
            Nessun risultato.
        </div>

        <div class="search-loading" *ngIf="searchLoading">
            Sto cercando…
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner"></div>
</div>

<!-- Popup conferma duplicazione -->
<div class="confirm-dup-overlay" *ngIf="confirmDupVisible" (click)="onCancelDuplication()">
    <div class="confirm-dup-dialog" (click)="$event.stopPropagation()">
        <p>Sei sicuro di voler duplicare <strong>{{ itemToDuplicate?.name }}</strong>?</p>
        <div class="confirm-dup-buttons">
            <button class="btn-cancel" (click)="onCancelDuplication()">Annulla</button>
            <button class="btn-confirm" (click)="onConfirmDuplication()">Duplica</button>
        </div>
    </div>
</div>